import styled from "styled-components";
import { CLOUDN_COLORS, COLORS } from "../../../constants/colors";
import { LinkTotalTitleProps } from "../../../constants/types";
import { useEffect, useState } from "react";
import { getLinkTotalPercent } from "../../../constants/function";

const LinkTotalTitle = (props: LinkTotalTitleProps) => {
  const [per, setPer] = useState(0);

  useEffect(() => {
    setPer(getLinkTotalPercent(props.total, props.disconnected));
  }, [props]);
  return (
    <Container>
      <span className="text">전체 디바이스 통신상태</span>
      <div
        className="total"
        style={{
          background: `linear-gradient(to left, ${COLORS.lightGray2} ${
            100 - per
          }%, ${CLOUDN_COLORS.skyBlue} ${100 - per}% )`,
        }}
      >
        {props.total.toLocaleString()} /{" "}
        {(props.total - props.disconnected).toLocaleString()} ( {per.toFixed(1)}{" "}
        % )
      </div>
    </Container>
  );
};

export default LinkTotalTitle;

const Container = styled.div`
  width: 100%;
  height: 12%;

  box-sizing: border-box;

  .text {
    font-size: 1.5vw;
    width: 100%;
    display: inline-block;
  }

  .total {
    font-size: 1vw;
    font-weight: 500;
    background-color: ${COLORS.lightGray2};
    width: 100%;
    height: 30%;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 2%;
    box-sizing: border-box;
    border-radius: 0.2vw;
    margin-top: 2%;
  }
`;
